import React from 'react';
import { useIntl } from 'react-intl';
import RowElementWrapper from '../../../common/row-element-wrapper';
import { ISelectedOptionIds } from '../../../../models/product-detail';
import { LARGER_STYLE_ID } from '../../../common/constants';

interface ILargerStyleProps {
    selectedIds: ISelectedOptionIds;
    onChange: (rightSelectedIds: number[], leftSelectedIds: number[]) => void;
    side: string;
}

const LargerStyle = ({ selectedIds, onChange, side }: ILargerStyleProps) => {
    const intl = useIntl();
    const isLargerStyle = (x: number) => {
        return (
            (side !== 'R' &&
                (selectedIds.leftSelectedIds.includes(x) ||
                    (x !== LARGER_STYLE_ID &&
                        !selectedIds.leftSelectedIds.includes(
                            LARGER_STYLE_ID
                        )))) ||
            (side !== 'L' &&
                (selectedIds.rightSelectedIds.includes(x) ||
                    (x !== LARGER_STYLE_ID &&
                        !selectedIds.rightSelectedIds.includes(
                            LARGER_STYLE_ID
                        ))))
        );
    };

    const handleLargerStyleChanged = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        const parsedInput = parseInt(event.target.value);
        const right = [...selectedIds.rightSelectedIds];
        const left = [...selectedIds.leftSelectedIds];

        if (parsedInput === LARGER_STYLE_ID) {
            right.push(parsedInput);
            left.push(parsedInput);
        }
        if (parsedInput === 0) {
            right.splice(right.indexOf(LARGER_STYLE_ID), 1);
            left.splice(left.indexOf(LARGER_STYLE_ID), 1);
        }
        onChange(right, left);
    };

    return (
        <>
            <RowElementWrapper>
                <label>
                    {intl.formatMessage({
                        id: 'TO_AVOID_PROTRUSION_OK_TO_CHANGE_TO_LARGER_STYLE?',
                        defaultMessage:
                            'To avoid protrusion, OK to change to larger style?',
                    })}
                </label>
                <RowElementWrapper>
                    {[LARGER_STYLE_ID, 0].map((option, index) => {
                        return (
                            <p
                                style={{
                                    display: 'inline',
                                    margin: '0px 25px 0px 25px',
                                }}
                                key={index}
                            >
                                <input
                                    type="Radio"
                                    name="largerStyleChoice"
                                    id={option + 'LargerStyleChoice'}
                                    checked={isLargerStyle(option)}
                                    value={option}
                                    onChange={(e) =>
                                        handleLargerStyleChanged(e)
                                    }
                                />
                                <label htmlFor={option + 'LargerStyleChoice'}>
                                    {option === LARGER_STYLE_ID
                                        ? intl.formatMessage({
                                              id: 'Yes',
                                              defaultMessage: 'Yes',
                                          })
                                        : intl.formatMessage({
                                              id: 'No',
                                              defaultMessage: 'No',
                                          })}
                                </label>
                            </p>
                        );
                    })}
                </RowElementWrapper>
            </RowElementWrapper>
        </>
    );
};

export default LargerStyle;
